export class Reminder {
  public id?: any;
  public author?: any;
  public is_send?: any;
  public send_date?: any;
  public status?: any;
  public content?: any;
  public date?: any;
  public time?: any;
  public text?: any;
}
